export enum ROSTER_TAB {
  DAILY = 'daily',
  WEEKLY = 'weekly',
}

export enum ROSTER_DISPLAY_MODE {
  OPEN_SLOTS = 'open-slots',
  CUSTOMERS = 'customers',
  TEAM_MEMBERS = 'team-members',
  ALL = 'all',
}
